import Row from 'react-bootstrap/Row';
import { Alert } from 'react-bootstrap';
import TextInput from '../../components/Inputs/TextInput';
import { ReportRecipientProps } from './types';
import RadioButtonGroup from '../../components/Inputs/RadioButtonGroup';
import { ReportRecipientStep } from '../../api/web-api-client';
import { prefixedPropertyOf } from '../../utils';
import HidableField from '../../components/forms/HidableField';
import AddressLookup from '../../components/Inputs/AddressLookup';

const getName = prefixedPropertyOf<ReportRecipientStep>('reportRecipient');

function getNameForUse2(name: string | keyof ReportRecipientStep, isSummary: boolean | undefined) {
    const fullname = isSummary ? getName(name as keyof ReportRecipientStep) : name;
    return fullname;
}

const ReportRecipient = (props: ReportRecipientProps) => {
    const { isSummary } = props;

    function getNameForUse(name: string | keyof ReportRecipientStep): string { return getNameForUse2(name, isSummary); }

    return (
        <>
            {!isSummary
                ? (
                    <Alert
                        variant='info'
                        data-testid='info-summary'
                        role='status'
                        aria-live='polite'
                        className='d-flex mb-4'
                    >
                        <div className='d-flex justify-content-center justify-content-md-start mb-3 mb-md-0'>
                            <div className='bgCircle mb-3 me-3'>
                                <i className='icon-info' aria-hidden='true' />
                            </div>
                        </div>
                        <div>
                            <strong>Important information</strong>
                            <p>
                                You may nominate an organisation for the report by filling out the details below.
                            </p>
                            <p>
                                <strong>Note: </strong>
                                The Measurement report will be addressed to the organisation provided below. The report will be made available only through the Portal and to the organisation submitting the request.
                            </p>
                        </div>
                    </Alert>
                ) : null}
            <Row className={isSummary ? '' : 'mb-4'}>
                <RadioButtonGroup
                    legend='Which organisation should the report be provided to?'
                    name={getNameForUse('organisationDifferent')}
                    id='q-organisationDifferent'
                    isSummary={isSummary}
                    options={[
                        {
                            label: 'The requesting organisation',
                            value: 'No',
                            id: 'organisationDifferent-No',
                        },
                        {
                            label: 'A different organisation',
                            value: 'Yes',
                            id: 'organisationDifferent-Yes',
                        }]}
                />
            </Row>
            {isSummary && (
                <HidableField name={getNameForUse('rfqHide')}>
                    <Row className='mb-4'>
                        <h2 className='h3 my-3'>
                            Report recipient organisation
                        </h2>
                        <TextInput key='orgName' label='Organisation name' name='rfqOrganisation.name' isSummary={isSummary} />
                        <AddressLookup
                            name='rfqOrganisation.streetAddress'
                            label='Business street address'
                            maxResults={10}
                            key='businessStreetAddress'
                            placeholder='Start typing the business street address'
                            isSummary={isSummary}
                        />
                    </Row>
                </HidableField>
            )}
            <HidableField name={getNameForUse('organisationNameHide')}>
                <Row className='mb-4'>
                    <h2 className={isSummary ? 'h3 my-3' : ''}>
                        Report recipient organisation
                    </h2>
                    <TextInput key='orgName' label='Organisation name' name={getNameForUse('organisationName')} isSummary={isSummary} />
                    <AddressLookup
                        name={getNameForUse('businessStreetAddress')}
                        label='Business street address'
                        maxResults={10}
                        key='businessStreetAddress'
                        placeholder='Start typing the business street address'
                        isSummary={isSummary}
                    />
                </Row>
            </HidableField>
        </>
    );
};

export default ReportRecipient;
